module.exports = __webpack_public_path__ + "static/media/Blind_skier_and_guide.f068a956.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Blind_skier_and_guide.jpg
// module id = 938
// module chunks = 0